import {Store,Module,ActionContext} from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import MoistureHandlewarning from '../entities/moisturehandlewarning'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
interface MoistureHandlewarningState extends ListState<MoistureHandlewarning>{
    editMoistureHandlewarning:MoistureHandlewarning
}
class UserMutations extends ListMutations<MoistureHandlewarning>{

}
class MoistureHandlewarningModule extends ListModule<MoistureHandlewarningState,any,MoistureHandlewarning>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize:10,
        list: new Array<MoistureHandlewarning>(),
        filterlist:new Array<MoistureHandlewarning>(),
        loading:false,
        editMoistureHandlewarning:new MoistureHandlewarning()
    }
    actions={
        async getAll(context:ActionContext<MoistureHandlewarningState,any>,payload:any){
            //console.log(payload.data);
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/MoistureHandlewarning/GetPaged',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<MoistureHandlewarning>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
            context.state.filterlist=page.items;
        },
        async getPaged(context:ActionContext<MoistureHandlewarningState,any>,payload:any){
          
            context.state.loading=true;
            //debugger
            let reponse=await Ajax.get('/api/services/app/MoistureHandlewarning/GetPaged',{params:payload.data});
            
            context.state.loading=false;
            let page=reponse.data.result as PageResult<MoistureHandlewarning>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
            context.state.filterlist=page.items;
        },
        async getfilter(context:ActionContext<MoistureHandlewarningState,any>,payload:any){
            //console.log(payload.data);
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/MoistureHandlewarning/GetAll',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<MoistureHandlewarning>;
            context.state.totalCount=page.totalCount;
            context.state.filterlist=page.items;
        },
        async create(context:ActionContext<MoistureHandlewarningState,any>,payload:any){
            await Ajax.post('/api/services/app/MoistureHandlewarning/Create',payload.data);
        },
        async uploadimg(context:ActionContext<MoistureHandlewarningState,any>,payload:any){
            //console.log(payload.data.UploadData);
            await Ajax.post('/api/services/app/UploadFile/UploadFile',{params:payload.data.UploadData});
        },
        async update(context:ActionContext<MoistureHandlewarningState,any>,payload:any){
            await Ajax.put('/api/services/app/MoistureHandlewarning/Update',payload.data);
        },
        async delete(context:ActionContext<MoistureHandlewarningState,any>,payload:any){
            await Ajax.delete('/api/services/app/MoistureHandlewarning/Delete?Id='+payload.data.id);
        },
        async get(context:ActionContext<MoistureHandlewarningState,any>,payload:any){
            let reponse=await Ajax.get('/api/services/app/MoistureHandlewarning/GetById?Id='+payload.id);
            return reponse.data.result as MoistureHandlewarning;
        }
    };
    mutations={
        setCurrentPage(state:MoistureHandlewarningState,page:number){
            state.currentPage=page;
        },
        setPageSize(state:MoistureHandlewarningState,pagesize:number){
            state.pageSize=pagesize;
        },
        edit(state:MoistureHandlewarningState,MoistureHandlewarning:MoistureHandlewarning){
            
            state.editMoistureHandlewarning=MoistureHandlewarning;
            //console.log(state.editFloor);
        }
    }
}
const moisturehandlewarningModule=new MoistureHandlewarningModule();
export default moisturehandlewarningModule;